import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../config.json"; // ajuste le chemin si nécessaire
import { useTranslation } from "react-i18next";
import axios from "axios";

const SubcategoriesHistory = ({ subcategory, fetchSubcategories }) => {
  const { t } = useTranslation();
  const { _id, subCategoryDetails = [], isArchived } = subcategory;

  // Fonction pour "désarchiver" la subcategory
  const unarchiveSubcategory = async () => {
    try {
      await axios.put(
        `${config.dev}/v2/subcategories/${_id}/unarchive`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          },
        }
      );
      swal(t("successTitle"), t("subcategoryUnarchived"), "success");
      fetchSubcategories();
    } catch (error) {
      console.error(error);
      swal(t("errorTitle"), "" + error, "error");
    }
  };

  const deleteSubcategoryForever = async () => {
    const ok = await swal({
      title: t("areYouSure") || "Are you sure?",
      text: t("deleteForeverWarning") || "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (!ok) return;
    try {
      await axios.delete(`${config.dev}/v2/subcategories/${_id}/delete-permanent`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      });
      swal(t("successTitle"), t("deletedSuccessfully") || "Deleted permanently", "success");
      fetchSubcategories();
    } catch (error) {
      swal(t("errorTitle"), error?.response?.data?.message || "" + error, "error");
    }
  };

  // On n'affiche QUE les subcategories archivées
  if (!isArchived) return null;

  // Cherche le titre anglais pour affichage
  const englishTitle = subCategoryDetails.find(
    (item) => item.language === "en"
  )?.title;

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card shadow-sm">
        <div className="card-body">
          {/* Dropdown actions */}
          <div className="d-flex justify-content-end">
            <Dropdown>
              <Dropdown.Toggle
                variant="dark"
                className="btn-sm border-0"
                style={{ backgroundColor: "#FA8072" }}
              >
                <i className="fa fa-ellipsis-v"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/subcategory-details/${_id}`}>
                  <i className="fa fa-eye me-2" />
                  {t("details")}
                </Dropdown.Item>
                <Dropdown.Item onClick={unarchiveSubcategory}>
                  <i className="fa fa-archive me-2" />
                  {t("unarchive")}
                </Dropdown.Item>
                <Dropdown.Item onClick={deleteSubcategoryForever}>
                  <i className="fa fa-trash me-2 text-danger" />
                  {t("deleteForever") || "Delete forever"}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* Contenu */}
          <div className="text-center mt-3">
            <h5 style={{ fontWeight: "bold" }}>
              {englishTitle || t("noTitle")}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubcategoriesHistory;
